import Vue from 'vue';

/**
 * Display the specified modal component based on the set of options
 * provided (if provided).
 *
 * @param {string|Object} component - The name or instance of the component
 * @param {Object} options - An optional set of properties for the component
 * @return {Promise}
 */
function showModal(component, options) {
    let me = this;
    return new Promise(function(resolve, close) {
        me.$root.modal = {
            component: component,
            options: options || {},
            resolveHandler: resolve,
            closeHandler: close
        };
    });
}

export default Vue => {
    Vue.prototype.$modal = showModal;
};
